import React from "react";
import { Form } from "react-bootstrap";
import { FieldProps } from "formik";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";
import { LinkIcon } from "../components/svgs";

const InputFloatingLabel: React.FC<FormikFieldCustomProps &
  FieldProps & { handleBlur: () => {} }> = ({
  field: { ...fields },
  form: { touched, errors },
  ...props
}) => (
  <Form.Group>
    <div className="f-group">
      <Form.Control
        {...props}
        {...fields}
        onBlur={props.handleBlur}
        onChange={(e: any) => {
          if (fields.onChange) fields.onChange(e);
        }}
        isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
      />
      {props.label && (
        <Form.Label htmlFor={props.id} className="f-label">
          {props.required ? <b>{props.label}</b> : props.label}
          {props.required && <span className="text-danger">*</span>}
        </Form.Label>
      )}
      {props.icon && props.icon === 'link' && <LinkIcon />}
    </div>
    <Form.Control.Feedback type="invalid">
      {errors[fields.name]}
    </Form.Control.Feedback>
  </Form.Group>
);

export default InputFloatingLabel;
